import * as types from '../types'
import {
  unique
} from '../../util'

/**
 * 购物车
 * list: 购物车内商品
 * cartsNum: 购物车内商品总数
 * checks: 购物车选中商品 [sku_id数组; 对应数目; 对应单价]
 * total: 购物车选中商品金额
 * @type {Object}
 */
const state = {
  list: [],
  cartsNum: 0,
  checks: [],
  total: 0.00,
}

const getters = {

}

const actions = {

}

const mutations = {
  /**
   * 购物车初始化
   * @type {[type]}
   */
  [types.INIT_CARTS](state, params) {
    let money = 0
    let obj = {}

    let list = params.skus.filter(item => parseInt(item.number) > 0)

    state.list = list
    state.cartsNum = params.sku_numbers
    state.checks = []
    state.total = 0.00

    if (state.list && state.list.length > 0) {
        state.list.forEach((item) => {
          obj = {
            sku_id: item.sku_id,
            num: parseInt(item.number),
            unit_price: (item._sku_.prom_price != '0.00') ? parseFloat(item._sku_.prom_price) : parseFloat(item._sku_.shop_price)
          }

          state.checks.push(obj)
          money += parseInt(item.prices * 100)
        })
    }

    state.total = money / 100
  },

  /**
   * 删除商品
   * ids -> 商品sku_id数组
   * @type {[type]}
   */
  [types.AJAX_DELETE_CARTS](state, ids) {
    let money = 0
    let num = 0

    /** 购物车商品数组更新 **/
    state.list = state.list.filter(val => ids.indexOf(val.sku_id) == -1)

    /** 选中商品数组更新 **/
    state.checks = state.checks.filter((item) => {
      let valid = ids.indexOf(item.sku_id) != -1
      if (valid) {
          money += item.num * (item.unit_price * 100)
          num += parseInt(item.num)
      }

      return !valid
    })

    /** 更新商品列表总数 **/
    state.cartsNum = ((state.cartsNum - num) >= 0) ? state.cartsNum - num : 0

    /** 更新选中商品金额 **/
    if (parseInt(state.total) > 0) state.total -= money / 100
  },

  /**
   * 更新某个商品的数量
   * params
   * sku_id: 商品sku_id
   * index: 商品索引
   * num: 商品数目
   */
  [types.AJAX_CHANGE_GOODS_NUM](state, params) {
    let unit_price = 0,
      settlement = 0,
      dir = 0,
      dirNum = 0,
      curPrices = 0,
      item = state.list[params.index]

    /** 更新商品列表 **/
    curPrices = parseInt(item.prices * 100)
    unit_price = curPrices / parseInt(item.number)
    settlement = unit_price * parseInt(params.num)
    dir = settlement - curPrices
    dirNum = parseInt(params.num) - parseInt(item.number)

    item.number = params.num
    item.prices = settlement / 100

    /** 更新商品总数 **/
    state.cartsNum += dirNum

    /** 更新选中商品信息(数量) **/
    if (state.checks && state.checks.length > 0) {
        state.checks.forEach((val) => {
          if (val.sku_id == params.sku_id) {
            val.num = params.num

            //更新选中商品总金额
            state.total = ((state.total * 100) + dir) / 100
          }
        })
    }
  },

  /**
   * 勾选商品
   * arr 商品sku_id数组
   * @type {Array}
   */
  [types.AJAX_CHECK_GOODS](state, arr) {
    state.checks = []
    let obj = {},
      money = 0

    if (state.list && state.list.length > 0) {
        state.list.forEach((item) => {
          if (arr.indexOf(item.sku_id) != -1) {
            obj = {
              sku_id: item.sku_id,
              num: parseInt(item.number),
              unit_price: (item._sku_.prom_price != '0.00') ? parseFloat(item._sku_.prom_price) : parseFloat(item._sku_.shop_price)
            }

            state.checks.push(obj)
            money += parseInt(item.prices * 100)
          }
        })
    }

    state.total = money / 100
  },

  /** 取消全选 **/
  [types.UNCHECK_ALL](state) {
    state.checks = []
    state.total = 0.00
  },

  /**
   * 更新购物车商品总数
   * params.num 正负数
   * params.type 1-初始化 2-加减
   **/
  [types.UPDATE_CARTS_NUM](state, params) {
    if (params.type == 1) {
      state.cartsNum = params.num
    } else {
      state.cartsNum += params.num
    }
},
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/carts.js